module.exports = __webpack_public_path__ + "img/lottery_background.c10ce8b2.png";